import React, { useEffect, useRef, useState } from 'react';
import { history, useLocation } from 'umi';
import { Toast,Tabs } from 'antd-mobile';
import styles from './styles.scss';
import {Page } from 'react-weui';
import { getDetail,getProgramVideos,setVideoPlay,setVideoPlayEnd } from '@/services/program';
import TabDirectory from './TabDirectory';
import TabComment from './TabComment';


export default (props) => {
  const programId = props.location.query.programId;
  const videoId = props.location.query.videoId;
  const [tabs,setTabs] = useState([
    { title: '目录' },
    { title: '评论' },
  ]);

  const [page, setPage] = useState(0);
  const [playDir,setPlayDir] = useState(null);
  const [isPlay,setIsPlay] = useState(false);
  const [program,setProgram] = useState(null);

  const videoRef = useRef();
  const tabDirRef = useRef();

  useEffect(()=>{
    document.title = props.location.query.title;

    Toast.loading('loading',60);
    getDetail({id:programId}).then(res => {
      Toast.hide();
      if (res.code == 200) {
        setProgram(res.data);

        document.title = res.data.name;
      } else {
        Toast.fail(res.message,1);
      }
    }).catch(e =>{
      Toast.hide();
      Toast.fail('获取失败，请重试',1);

    });
  },[]);






  if (!program) {
    return(
      <Page transition={true} infiniteLoader={false} ptr={false}>
      </Page>
    )
  }

  return (
    <Page transition={true} infiniteLoader={false} ptr={false}>
      <div className={styles.box}>
        {isPlay && playDir ?
          <div className={styles.headerBox} >
            <video ref={videoRef}
                   className={styles.video}
                   controls="controls"
                   onEnded={()=> {
                     setIsPlay(false);
                     endPlay();
                   }}
                   onLoadStart={()=>{
                     startPlay();
                   }}
            >
              <source src={playDir.playAddress} type="video/mp4"/>
              您的浏览器不支持HTML5视频
            </video>
          </div>
          :
          <div className={styles.headerBox} >
            <img className={styles.cover} src={playDir ? playDir.image : program.image} alt=''/>

            {playDir && (
              <img className={styles.playIcon} src={require('@/assets/ic_play.png')}
                   onClick={()=>{
                     tabDirRef.current.defaultPlay();
                   }}/>
            )}
          </div>}


        <Tabs
          tabs={tabs}
          initialPage={0} page={page}
          tabBarActiveTextColor={'#333333'}
          tabBarInactiveTextColor={'#888888'}
          tabBarUnderlineStyle={{ backgroundColor: 'transparent', height: '2' }}
          onChange={(tab, index) => {
            setPage(index)
          }}
          onTabClick={(tab, index) => {
            setPage(index)
          }}
        >

          <TabDirectory ref={tabDirRef} program={program}
                        selectId={videoId}
                        onDirSelect={(dir) =>{
                          setPlayDir(dir);
                        }}
                        onDirClick={(dir) =>{
                          setIsPlay(true);
                          if (videoRef.current) {
                            videoRef.current.load();
                            videoRef.current.play();
                          }

                        }}
                        goComment={()=>{
                          setPage(1);
                        }}

          />


          <TabComment program={program} getCommentCount={(count) => {
            setTabs([
              { title: '目录' },
              { title: '评论' + (count > 0 ? '('+ count+')' : '') },
            ])
          }}/>

        </Tabs>
      </div>
    </Page>
  )



  function startPlay() {
    setVideoPlay({id:playDir.id}).then(res => {
      console.log(res);
    });
  }


  function endPlay() {
   setVideoPlayEnd({id:playDir.id}).then(res => {
     console.log(res);
   });
  }
}
